// extracted by mini-css-extract-plugin
export var actionButton = "_kl-0";
export var fileInput = "_kl-2";
export var paperclip = "_kl-1";